import { Grid, MenuItem, Select, InputLabel, FormControl } from "@mui/material";
import React, { useContext } from "react";
import Header from "../Header/Header";
import "./footer.scss";

import { Link } from "react-router-dom";

import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";

import { ThemeContext } from "../DarkMode/ThemeProvider";

import qrcode from "../../Img/qrcode.png";
import social1 from "../../Img/social1.png";
import social2 from "../../Img/social2.png";
import social3 from "../../Img/social3.png";
import social4 from "../../Img/social4.png";
import social5 from "../../Img/social5.png";
import social6 from "../../Img/social6.png";
import instagram_white from "../../Img/instagram_white.svg";
import qrscan from "../../Img/qrscan.png";
import lightlogo from "../../Img/light-mode-logo.png";
import darkLogo from "../../Img/light-mode-logo.png";
import consts from "../../constant";

const Footer = () => {
  const [age, setAge] = React.useState("");

  const handleChange = (event) => {
    setAge(event.target.value);
  };
  const { isLightMode, handleDarkmode } = useContext(ThemeContext);
  return (
    <div>
      <footer>
        <div className="contain-width">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
              <div className="text-center"></div>
              <img src={darkLogo} className="logo" width={100} height={50} />

              <div className="scan">
                <p>Scan for App</p>
                <img src={qrscan} alt="qr" />
              </div>

              <h5 className="white">Community</h5>
              <ul className="social">
                {/* <li><a href="#"><svg width="32" height="19" viewBox="0 0 32 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.03875 0.26416C14.0138 0.26416 18.0462 4.32478 18.0462 9.33353C18.0462 14.3423 14.0131 18.4029 9.03875 18.4029C4.06437 18.4029 0.03125 14.3423 0.03125 9.33353C0.03125 4.32478 4.06375 0.26416 9.03875 0.26416ZM23.4231 0.79541C25.9106 0.79541 27.9269 4.61791 27.9269 9.33353C27.935 10.4704 27.4519 17.8717 23.4231 17.8717C20.9362 17.8717 18.9194 14.0479 18.9194 9.33353C18.9194 4.61916 20.9356 0.79541 23.4231 0.79541ZM30.385 1.68478C31.2594 1.68478 31.9688 5.10916 31.9688 9.33353C31.9688 13.5567 31.26 16.9823 30.385 16.9823C29.51 16.9823 28.8013 13.5579 28.8013 9.33353C28.8013 5.10978 29.51 1.68478 30.385 1.68478Z" fill="white" /></svg></a></li>
                                <li><a href="#"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M31.4387 16.3331C31.4387 24.8622 24.5256 31.777 15.9952 31.777C7.46566 31.777 0.551758 24.8622 0.551758 16.3331C0.551758 7.80452 7.46569 0.890137 15.9952 0.890137C24.5256 0.890137 31.4387 7.80452 31.4387 16.3331ZM8.66273 22.7925H11.6732V13.159H8.66273V22.7925ZM10.0692 11.9539H10.0908C11.2223 11.9539 11.9273 11.2152 11.9273 10.2819C11.9054 9.33134 11.2223 8.61182 10.1121 8.61182C9.00104 8.61182 8.27344 9.33317 8.27344 10.2846C8.27344 11.2175 8.97981 11.9539 10.0692 11.9539ZM20.3035 22.7925H23.7168V17.4357C23.7168 14.4522 22.0361 13.0663 19.8973 13.0663C18.1722 13.0663 17.092 14.0098 16.8921 14.6708V13.159H13.5106C13.5545 13.9618 13.5106 22.7924 13.5106 22.7924H16.8921V17.5798C16.8921 17.5457 16.8919 17.5115 16.8917 17.4775C16.8904 17.2225 16.889 16.9755 16.9657 16.7924C17.1985 16.2128 17.6973 15.612 18.5956 15.612C19.77 15.612 20.3035 16.5025 20.3035 17.8072V22.7925Z" fill="white" /></svg></a></li>
                                <li><a href="#"><svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M13 0.833496C6.1015 0.833496 0.5 6.4345 0.5 13.3335C0.5 20.2335 6.101 25.8335 13 25.8335C19.9 25.8335 25.5 20.2335 25.5 13.3335C25.5 6.435 19.9 0.833496 13 0.833496ZM18.434 7.0685C18.608 7.01015 18.7947 7.00087 18.9737 7.04167C19.1526 7.08247 19.3168 7.17177 19.4483 7.29978C19.5799 7.42778 19.6736 7.58955 19.7192 7.76731C19.7648 7.94508 19.7606 8.13197 19.707 8.3075C18.727 11.526 16.728 18.0965 15.8065 21.125C15.7562 21.2902 15.664 21.4397 15.5389 21.5587C15.4137 21.6777 15.2599 21.7623 15.0923 21.8042C14.9247 21.8461 14.7492 21.8439 14.5827 21.7977C14.4163 21.7516 14.2646 21.6632 14.1425 21.541C12.8415 20.241 10.826 18.225 10.0175 17.416C9.92376 17.3222 9.87111 17.1951 9.87111 17.0625C9.87111 16.9299 9.92376 16.8028 10.0175 16.709L15.1215 11.605C15.2115 11.5152 15.2639 11.3945 15.2681 11.2674C15.2722 11.1403 15.2278 11.0164 15.1438 10.9209C15.0599 10.8254 14.9427 10.7655 14.8161 10.7533C14.6895 10.7412 14.5631 10.7777 14.4625 10.8555L8.5435 15.422C8.4585 15.4876 8.35465 15.524 8.24732 15.526C8.13998 15.528 8.03486 15.4954 7.9475 15.433L4.8975 13.254C4.74737 13.1468 4.62983 13.0001 4.55787 12.8303C4.48591 12.6604 4.46234 12.4739 4.48977 12.2915C4.5172 12.1091 4.59456 11.9378 4.71328 11.7966C4.83201 11.6554 4.98748 11.5498 5.1625 11.4915L18.434 7.0685Z" fill="white" /></svg></a></li>
                                <li><a href="#"><svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.256 0.476075C12.3603 0.475442 9.52954 1.33352 7.12158 2.9418C4.71362 4.55008 2.83668 6.83632 1.72812 9.51137C0.619564 12.1864 0.329187 15.1301 0.893713 17.9702C1.45824 20.8103 2.85231 23.4192 4.89962 25.467C6.94694 27.5147 9.55553 28.9094 12.3955 29.4745C15.2355 30.0397 18.1792 29.75 20.8545 28.642C23.5298 27.534 25.8165 25.6576 27.4253 23.25C29.0341 20.8424 29.8928 18.0117 29.8928 15.1161C29.8886 11.2352 28.3452 7.51436 25.6013 4.76984C22.8574 2.02531 19.1369 0.481156 15.256 0.476075ZM19.3168 9.16087C19.3168 9.21943 19.2935 9.2756 19.2521 9.317C19.2107 9.35841 19.1546 9.38167 19.096 9.38167H17.336C17.1286 9.38167 16.9297 9.46383 16.7828 9.61017C16.6358 9.75651 16.5528 9.9551 16.552 10.1625V12.0057H19.0576C19.088 12.006 19.118 12.0126 19.1458 12.0251C19.1735 12.0375 19.1984 12.0556 19.2188 12.0782C19.2392 12.1007 19.2548 12.1272 19.2645 12.156C19.2742 12.1849 19.2778 12.2154 19.2752 12.2457L19.0576 14.8441C19.0528 14.8992 19.0274 14.9506 18.9865 14.9879C18.9456 15.0253 18.8922 15.0459 18.8368 15.0457H16.552V23.6697C16.552 23.7282 16.5287 23.7844 16.4873 23.8258C16.4459 23.8672 16.3898 23.8905 16.3312 23.8905H13.1792C13.1206 23.8905 13.0645 23.8672 13.0231 23.8258C12.9817 23.7844 12.9584 23.7282 12.9584 23.6697V15.0457H11.384C11.3254 15.0457 11.2693 15.0224 11.2279 14.981C11.1865 14.9396 11.1632 14.8834 11.1632 14.8249V12.2265C11.1632 12.1679 11.1865 12.1118 11.2279 12.0703C11.2693 12.0289 11.3254 12.0057 11.384 12.0057H12.9584V9.50327C12.9584 8.66477 13.2915 7.8606 13.8844 7.26769C14.4773 6.67477 15.2815 6.34167 16.12 6.34167H19.096C19.1546 6.34167 19.2107 6.36494 19.2521 6.40634C19.2935 6.44775 19.3168 6.50391 19.3168 6.56247V9.16087Z" fill="white" /></svg></a></li> */}
                <li>
                  <a href="https://www.instagram.com/Dreamster-Exchange">
                    <img src={instagram_white} alt="instagram" />
                  </a>
                </li>
                <li>
                  <a href="https://www.youtube.com/channel/UCXWUDyi_A-Ntb9OjmHvA0yQ">
                    <svg
                      width="32"
                      height="23"
                      viewBox="0 0 32 23"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M30.64 2.45398C29.772 0.909984 28.83 0.625984 26.912 0.517984C24.996 0.387984 20.178 0.333984 16.004 0.333984C11.822 0.333984 7.002 0.387985 5.088 0.515985C3.174 0.625985 2.23 0.907984 1.354 2.45398C0.46 3.99598 0 6.65198 0 11.328V11.344C0 16 0.46 18.676 1.354 20.202C2.23 21.746 3.172 22.026 5.086 22.156C7.002 22.268 11.822 22.334 16.004 22.334C20.178 22.334 24.996 22.268 26.914 22.158C28.832 22.028 29.774 21.748 30.642 20.204C31.544 18.678 32 16.002 32 11.346V11.33C32 6.65198 31.544 3.99598 30.64 2.45398ZM12 17.334V5.33398L22 11.334L12 17.334Z"
                        fill="white"
                      />
                    </svg>
                  </a>
                </li>
                <li>
                  <a href=" https://x.com/Dreamster-Exchange?s=21">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M15.9835 31.089C24.5127 31.089 31.4269 24.1748 31.4269 15.6456C31.4269 7.11641 24.5127 0.202148 15.9835 0.202148C7.4543 0.202148 0.540039 7.11641 0.540039 15.6456C0.540039 24.1748 7.4543 31.089 15.9835 31.089ZM16.9285 13.096L21.9322 7.2797H23.9794L17.8377 14.4189L24.4293 24.0118H19.1031L14.8766 17.8608L9.58507 24.0118H7.53775L13.9677 16.5381L7.60599 7.2797H12.9321L16.9285 13.096Z"
                        fill="white"
                      />
                    </svg>
                  </a>
                </li>
              </ul>

              <a href="#" className="mail">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16 0C7.16375 0 0 7.16376 0 16C0 24.8363 7.16375 32 16 32C24.8363 32 32 24.8363 32 16C32 7.16376 24.8363 0 16 0ZM24.4375 20.9425C24.4364 21.3664 24.2675 21.7725 23.9678 22.0722C23.6681 22.3718 23.262 22.5408 22.8381 22.542H9.16188C8.73805 22.5408 8.33191 22.3718 8.03222 22.0722C7.73253 21.7725 7.56366 21.3664 7.5625 20.9425V12.5825L15.9963 16.7901L24.4375 12.6707V20.9425ZM24.4375 11.0937L16.0037 15.21L7.5625 11C7.57862 10.5865 7.75391 10.1954 8.05173 9.90813C8.34956 9.62091 8.74687 9.4599 9.16063 9.45876H22.8381C23.2619 9.45991 23.6678 9.6287 23.9676 9.92827C24.2672 10.2278 24.4362 10.6338 24.4375 11.0576V11.0937Z"
                    fill="white"
                  />
                </svg>
                <span>info@Dreamster-Exchange.com</span>
              </a>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={9} xl={9}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                  <h5>Company</h5>
                  <ul className="list">
                    <li>
                      <a href="#">White Papers</a>
                    </li>
                    <li>
                      <a href="#">About Us</a>
                    </li>
                    {/* <li>
                      <a href="#">Blog</a>
                    </li>
                    <li>
                      <a href="#">Referral Program</a>
                    </li>
                    <li>
                      <a href="#">Online Expo</a>
                    </li>
                    <li>
                      <a href="#">Our Teams</a>
                    </li>
                    <li>
                      <a href="#">Probinar Academy</a>
                    </li> */}
                  </ul>
                </Grid>
                {/* <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                  <h5>Legal</h5>
                  <ul className="list">
                    <li>
                      <a href="#">Term of use</a>
                    </li>
                    <li>
                      <a href="#">Privacy Policy</a>
                    </li>
                    <li>
                      <a href="#">Risk Disclosures</a>
                    </li>
                    <li>
                      <a href="#">Refund policy</a>
                    </li>
                    <li>
                      <a href="#">AML policy</a>
                    </li>
                  </ul>
                </Grid> */}
                <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                  <h5>Trade</h5>
                  <ul className="list">
                    <li>
                      <a href="#">Spot Trading</a>
                    </li>
                    <li>
                      <a href="#">Margin Trading</a>
                    </li>
                    <li>
                      <a href="#">Future Trading</a>
                    </li>
                    <li>
                      <a href="#">Instant Buy & Sell</a>
                    </li>
                  </ul>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                  <h5>Support</h5>
                  <ul className="list">
                    <li>
                      <a href="#">Support Center</a>
                    </li>
                    <li>
                      <a href="#">FAQ</a>
                    </li>
                    {/* <li>
                      <a href="#">How its works</a>
                    </li>
                    <li>
                      <a href="#">Contact Us</a>
                    </li> */}
                  </ul>
                </Grid>
                {/* <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                  <h5>Products</h5>
                  <ul className="list">
                    <li>
                      <a href="#">Blockchain</a>
                    </li>
                    <li>
                      <a href="#">NFT</a>
                    </li>
                    <li>
                      <a href="#">Defi</a>
                    </li>
                    <li>
                      <a href="#">Explore</a>
                    </li>
                    <li>
                      <a href="#">Wallet</a>
                    </li>
                    <li>
                      <a href="#">Payment</a>
                    </li>
                  </ul>
                </Grid> */}
                {/* <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                                    <h5>Explore</h5>
                                    <ul className="list">
                                        <li><a href="#">Compare Other Exchange</a></li>
                                        <li><a href="#">Right Exchange Identification</a></li>
                                        <li><a href="#">How to Claim USDT</a></li>
                                        <li><a href="#">Voting</a></li>
                                    </ul>
                                </Grid> */}
                <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                  <h5>Download</h5>
                  <ul className="list">
                    <li>
                      <a href="#">Download for Android</a>
                    </li>
                    <li>
                      <a href="#">Download for iOS</a>
                    </li>
                    {/* <li>
                      <a href="#">Download for Windows</a>
                    </li> */}
                  </ul>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
        <div className="blw_fx">
          <p className="mb">
            © {new Date().getFullYear()} Dreamster-Exchange.com. All Rights
            Reserved.{" "}
          </p>
          {/* <p>
            {" "}
            Legal name: Dreamster-Exchange BLOCKCHAIN TECH PRIVATE LIMITED | Reg
            Number: U85499TN2024PTC167179
          </p>
          <p>
            Registration Address: Dreamster-Exchange BLOCKCHAIN TECH PRIVATE LIMITED
          </p>
          <p className="mb">
            No.38/1, Bharathidasan Salai, TB Road, Arasaradi,Madurai- 625016.
          </p> */}
        </div>
      </footer>
    </div>
  );
};

export default Footer;
